import { isEqualWith } from "lodash";

export class BaseSnapshotModel {
  constructor() {
    this.Model = { modelFields: [], requiredFields: [] };
  }

  createSnapshot(values) {
    const snapshot = {};

    for (let fieldName of this.Model.modelFields) {
      snapshot[fieldName] = {
        value: values[fieldName],
        require_field: this.Model.requiredFields.includes(fieldName)
      };
    }

    return snapshot;
  }

  isEqual(original, latest) {
    let requireSave = false;

    //this methos using ty idenitfy if require_field is changed
    const isRequiredField = (value, sValue) => {
      if (
        value?.require_field &&
        sValue?.require_field &&
        value?.value != sValue?.value
      ) {
        requireSave = true;
        return false;
      }
    };

    return {
      isChanged: isEqualWith(
        this.createSnapshot(original),
        this.createSnapshot(latest),
        isRequiredField
      ),
      require: requireSave
    };
  }
}
